import { Col, Label, ReactSelectBox, Row, SofturaTable, Card, PrimaryButton, EventHandler } from "client/CommonComponents"
import { DateRangePicker } from "rsuite"
import excel from '../../../assets/images/Excel.svg'
import { FilteringMode } from 'ka-table/enums';
import './ApprovalHistoryandCompilanceReport.scss';

const { afterToday } = DateRangePicker;

const ApprovalHistory = (props: any) => {
    const {
        regionDropDownList,
        selectedRegion,
        marketDropDownList,
        selectedMarket,
        handleChange,
        costCentersByMarketList,
        pagesCount,
        selectedCostCenter,
        serverTotal,
        columns,
        showGrid,
        onExportExcel,
        fetchAction,
        searchCostCenter,
        costCentersBySearchList = [],
        handleChangeSearchedCostCenter,
        selectedSearchedCostCenter,
        onDateChange,
        dateRange,
        gridData,
        paginationData,
        search,
        getLocationFilter,
        isApprovalHistory,
        onClearClick,
        isMyOrdersGridLoading
    } = props
    return (
        <>
            <div className="row">
                <div className='penalityHeader margin-bottom-heading'>
                    <p className='headingText pull-left'>{isApprovalHistory ? "Approval History" : "Compliance Audit Report"}</p>
                </div>
            </div>
            <Row className="mb-2">
                <Col xs={12} sm={12} md={6} lg={3} className={`mb-2 ${(!selectedRegion) ? "regionnotselected" : ""}`}>
                    <Label data-attribute="ApprovalHistoryandComplianceReport_Default_Label">Region</Label>
                    <ReactSelectBox
                        name='region'
                        placeholder='Select Region'
                        options={regionDropDownList}
                        value={selectedRegion ?? ''}
                        onChange={(value: any) => handleChange(value, 'region')}
                        isSearchable={true}  data-attribute="ApprovalHistoryandComplianceReport_region_SearchSelectBox" />
                </Col>
                {selectedRegion && marketDropDownList?.length ?
                    <Col xs={12} sm={12} md={6} lg={3} className={`mb-2 ${(selectedRegion && !selectedMarket) ? "marketnotselected_approvalhistory" : null}`}>
                        <Label data-attribute="ApprovalHistoryandComplianceReport_Default_Label_2">Market</Label>
                        <ReactSelectBox
                            name='market'
                            placeholder='Select Market'
                            options={marketDropDownList}
                            value={selectedMarket ?? ''}
                            onChange={(value: any) => handleChange(value, 'market')}
                            isSearchable={true}  data-attribute="ApprovalHistoryandComplianceReport_market_SearchSelectBox" />
                    </Col>
                    : null}
                {selectedRegion && selectedMarket && costCentersByMarketList?.length ?
                    <Col xs={12} sm={12} md={6} lg={3} className="mb-2">
                        <Label data-attribute="ApprovalHistoryandComplianceReport_Default_Label_3">Cost Center</Label>
                        <ReactSelectBox
                            name='costCenter'
                            placeholder='Select Cost Center'
                            options={costCentersByMarketList}
                            onChange={(value: any) => handleChange(value, 'costCenter')}
                            value={selectedCostCenter ?? ''}
                            isSearchable={true}
                            className='mb-3'
                         data-attribute="ApprovalHistoryandComplianceReport_costCenter_SearchSelectBox" />
                    </Col> : null}
                <Col xs={12} sm={12} md={6} lg={3} className="mt-lg-4 mt-md-4 mt-2 pt-1 filter_search_btns">
                    <PrimaryButton
                        className="me-2"
                        onClick={search}
                        text="Search"
                        title="search"
                        disabled={isApprovalHistory ? !getLocationFilter()?.id : (selectedRegion?.label || selectedMarket?.label) ? false : true}
                     data-attribute="ApprovalHistoryandComplianceReport_search_Button">
                        Search
                    </PrimaryButton>

                    {selectedRegion ?
                        <PrimaryButton
                            onClick={onClearClick}
                            text="Clear Filters"
                            title="Clear Filters"
                         data-attribute="ApprovalHistoryandComplianceReport_Clear_Filters_Button">
                            Clear Filters
                        </PrimaryButton>
                        : null}
                </Col>

            </Row>
            <Row className="mb-3">
                <Col xs={12} sm={12} md={6} lg={3}>
                    <Label data-attribute="ApprovalHistoryandComplianceReport_Default_Label_4">Search for Cost Center</Label>
                    <ReactSelectBox
                        name='searchedCostCenter'
                        placeholder='Search Cost Center'
                        options={costCentersBySearchList}
                        onChange={(value: any) => handleChangeSearchedCostCenter(value, 'searchedCostCenter')}
                        onInputChange={searchCostCenter}
                        value={selectedSearchedCostCenter}
                        isSearchable={true}
                     data-attribute="ApprovalHistoryandComplianceReport_searchedCostCenter_SearchSelectBox" />
                </Col>
                <Col xs={12} sm={12} md={6} lg={3}>
                    <Label data-attribute="ApprovalHistoryandComplianceReport_Default_Label_5">{isApprovalHistory ? "Order Date" : "Modified On"}</Label>
                    <DateRangePicker
                        placement='bottomEnd'
                        format="MM/dd/yyyy"
                        character=' - '
                        onChange={onDateChange}
                        value={dateRange}
                        placeholder='MM/DD/YYYY - MM/DD/YYYY'
                        preventOverflow={true}
                        shouldDisableDate={afterToday?.()}
                     data-attribute="ApprovalHistoryandComplianceReport_Default_DateRangePicker" />
                </Col>
                {gridData?.length > 0 &&
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className='mb-1 top-section approval-hierarchy mt-lg-4 mt-md-0 mt-3'>
                            <div className='clearfix'>
                                <div className='btn-block-approvalhierarchy pull-right'>
                                    <div className={`excel-section-approvalhierarchy mt-1 ${gridData?.length ? "" : "disable-export-excel"}`}>
                                        <EventHandler onEvent={(e?: any) => { onExportExcel(e) }} data-attribute="ApprovalHistoryandComplianceReport_Default_EventHandler">
                                            <img
                                                src={excel}
                                                alt='excel'
                                                className={`${gridData?.length ? "" : "disable-approval-list-excel"}`}
                                            />
                                        </EventHandler>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                }
            </Row>
            <div className={`pe-0 ${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                {showGrid ?
                    <SofturaTable
                        data={gridData ?? []}
                        columns={columns}
                        sort={true}
                        defaultPageSize={paginationData?.pageSize ?? 10}
                        pageSizes={[10, 20, 50]}
                        globalSearch={false}
                        fixedHeader={true}
                        className="approvalHierarchy-grid"
                        filteringMode={FilteringMode.FilterRow}
                        serverTotal={serverTotal}
                        fetchAction={fetchAction}
                        isServerSide={true}
                        pagesCount={pagesCount}
                        defaultPaginationPosition='Both'
                        pageIndex={paginationData?.pageIndex ?? 0}
                        loading={isMyOrdersGridLoading}
                     data-attribute="ApprovalHistoryandComplianceReport_Default_Grid" />
                    : null}
            </div>

        </>
    )
}

export default ApprovalHistory